import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-circular-percentage',
  templateUrl: './circular.percentage.component.html',
  styleUrls: ['./circular.percentage.component.scss'],
})
export class CircularPercentageComponent {
  @Input()
  machineRunningRatio = 0;

  @Input()
  machineErrorRatio = 0;

  @Input()
  machineWaitRatio = 0;

  @Input()
  machineOverallConsumption: number | undefined = undefined;

  @Input()
  machinePowerAlgorithm: string | undefined = undefined;

}
